import { ISelectOption } from '../../../ui-toolkit';

export enum eAchPullPayerType {
  Borrower = 'borrower',
  Lender = 'lender',
  Seller = 'seller',
  ThirdParty = 'third_party',
}

export const prettyAchPullPayerType: Record<eAchPullPayerType, string> = {
  [eAchPullPayerType.Borrower]: 'Borrower',
  [eAchPullPayerType.Lender]: 'Lender',
  [eAchPullPayerType.Seller]: 'Seller',
  [eAchPullPayerType.ThirdParty]: 'Third Party',
};

export const achPullPayerTypeOptions: ISelectOption[] = Object.values(eAchPullPayerType).map((payerType) => ({
  label: prettyAchPullPayerType[payerType],
  value: payerType,
}));
